import React from 'react';
import { TableHead, TableRow, TableSortLabel, TableCell, Typography } from '@mui/material';

import RenderIf from '../../../../renderIf';

const DashboardHeader = (props) => {
    const { headers, disabled, handleSort, sortKey, sortDir } = props;

    return (
        <TableHead>
            <TableRow>
                {Object.entries(headers)?.map(([key, value]) => (
                    <TableCell key={`header-${key}`}>
                        <RenderIf isTrue={key !== 'Selected'}>
                            <TableSortLabel
                                active={sortKey === key}
                                direction={sortDir.toLowerCase()}
                                onClick={() => handleSort(key)}
                                sx={{ fontWeight: 700, color: 'grey.header', fontSize: '13px' }}
                                disabled={disabled}
                            >
                                {value}
                            </TableSortLabel>
                        </RenderIf>

                        <RenderIf isTrue={key === 'Selected'}>
                            <Typography sx={{ fontWeight: 700, color: 'grey.header', fontSize: '13px' }}>{value}</Typography>
                        </RenderIf>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default DashboardHeader;
